/**
 * Created by will on 6/30/14.
 */
applicationsSubNavbar.classy.controller({
    name: 'FutureController',
    inject: ['$scope', '$state', '$modalInstance', 'ApplicationsSubNavbarService', 'DateService', 
        'ApplicationService', 'AppModelService', 'BinFactory', 'BinFactory', 'SchoolModelService', '$timeout'],
    init: function () {
        this.$.currentYear = this.DateService.getCurrentYear();
        this.$.schoolinfo = this.SchoolModelService.get()[0];

        // Year_End and changeover start at 1, so skip index 0
        var monthArray = [null, "February", "March", "April", "May",
            "June", "July", "August", "September", "October", "November", "December", "January"];
        var changeoverArray = [null, "one week", "two weeks", "three weeks", 
            "one month", "two months", "three months"];

        this.$.rollover = monthArray[this.$.schoolinfo.Year_End];
        this.$.changeover = changeoverArray[this.$.schoolinfo.chgOvrPrd];

    },
    close: function()
    {
        this.$modalInstance.dismiss("cancel");
    },
    changeAppYear: function(scope, instance, form)
    {
        var parent = this;
        var app = this.ApplicationService.getAwardData().app[0];
        app.App_Fin_Year--;
        instance.options.factor  = .3;
        this.AppModelService.put(app.applicationID, {App_Fin_Year: app.App_Fin_Year}).then(function() {
            var app = parent.BinFactory.geAppByID(parent.ApplicationService.getAwardData().app[0].applicationID);
            app.App_Fin_Year--;
            parent.BinFactory.getBinCount();
            parent.$timeout(function() {
                parent.$modalInstance.dismiss('cancel');
            },1000);
        });
    }
});

